export const UNSPECIFIED_BREED = "__unspecified__";
export const UNSPECIFIED_BREED_LABEL = "Nieokreślona";

export function decodeGroupBreeds(stored: string | null | undefined): string[] | null {
  if (!stored?.trim()) {
    return null;
  }
  const text = stored.trim();
  if (text.startsWith("[")) {
    try {
      const parsed = JSON.parse(text) as unknown;
      if (Array.isArray(parsed)) {
        return parsed.map(String).filter(Boolean);
      }
    } catch {
      /* plain breed string */
    }
  }
  return [text];
}

export function formatGroupBreed(stored: string | null | undefined): string | null {
  const decoded = decodeGroupBreeds(stored);
  if (!decoded?.length) {
    return null;
  }
  return decoded
    .map((item) =>
      item === UNSPECIFIED_BREED ? UNSPECIFIED_BREED_LABEL : item,
    )
    .join(", ");
}

export function encodeGroupBreeds(selected: string[]): string | null {
  const cleaned = selected.map((item) => item.trim()).filter(Boolean);
  if (!cleaned.length) {
    return null;
  }
  if (cleaned.length === 1 && cleaned[0] !== UNSPECIFIED_BREED) {
    return cleaned[0];
  }
  return JSON.stringify(cleaned);
}
